import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
`
export const BlocoPrincipal = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`


export const DemandCard = styled.div